import { render, staticRenderFns } from "./UserOtherInterests.vue?vue&type=template&id=e56f10d4&"
import script from "./UserOtherInterests.vue?vue&type=script&lang=js&"
export * from "./UserOtherInterests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports